import { CATEGORY_ICONS, MAX_CREDIBLE_UPLIFT } from '../constants';
import type { ScoredComparable } from '../types';

interface ComparableProps {
  scoredComparable: ScoredComparable;
  className?: string;
}

export const Comparable = ({ scoredComparable, className }: ComparableProps) => {
  const { avv, category, label, vertical, lickdUpliftViews } = scoredComparable;
  const upliftPercent = Math.max(1, Math.round(lickdUpliftViews));

  const name = category?.label || label;
  const icon = category?.id ? CATEGORY_ICONS[category.id] : null;
  const body = category?.copy || null;

  return (
    <div className={`comp-card${className ? ` ${className}` : ''}`}>
      {icon && <div className="comp-icon">{icon}</div>}
      <div className="comp-content">
        <div className="comp-name">{name}</div>

        <div className="comp-body">
          {!!body && `${body} | `}
          {avv} AVV
        </div>

        <div className="comp-meta">
          <span className="badge badge-green">{vertical}</span>
        </div>
      </div>

      <div className="comp-uplift">
        {upliftPercent >= MAX_CREDIBLE_UPLIFT ? '> ' : ''}
        {upliftPercent}% more views
      </div>
    </div>
  );
};
